import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import Header from "../../Components/Header/Header";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControl,
  InputLabel,
  Button,
  TextField,
  Select,
  MenuItem,
} from "@material-ui/core/";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { lang } from "../../service/constants/constants";

import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import MuiAudioPlayer from "./../../Components/AudioPlayer";
import {
  fetchAudioTracks,
  saveAudioTracks,
  setPageName,
} from "./../../service/action/audio-track-action";
import { Loader, DatePicker } from "./../../Components";

class AudioToTrack extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      folderName: "2-11-19",
      filterValues: {
        startDate: "",
        endDate: "",
      },
      pageNumber: 1,
      records: {
        language: "",
        transcript: "",
      },
      recordsError: {},
      disableSubmit: true,
    };
    this.rederAudioFiles = this.rederAudioFiles.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    // console.log(nextProps)
    // console.log(this.props)
    const { records, recordsError } = this.state;
    if (this.props.audioList.data !== nextProps.audioList.data) {
      nextProps.audioList.data.map((item, i) => {
        records[item.id] = item.transcript;
        recordsError[item.id] = false;
      });
      this.setState({ records, recordsError });
    }
    if (this.props.success.message !== nextProps.success.message) {
      const {
        filterValues: { startDate, endDate },
        pageNumber,
      } = this.state;
      let start_date = "";
      let end_date = "";
      if (startDate !== "" && endDate !== "") {
        let sdate = new Date(startDate);
        let edate = new Date(endDate);
        start_date = `${sdate.getFullYear()}-${
          sdate.getMonth() + 1
        }-${sdate.getDate()} 00:00:00`;
        end_date = `${edate.getFullYear()}-${
          edate.getMonth() + 1
        }-${edate.getDate()} 23:59:59`;
      }
      this.props.fetchAudioTracks(
        cookie.load("username"),
        start_date,
        end_date,
        pageNumber,
        pageNumber * 10
      );
    }
  }

  componentWillMount() {
    this.props.setPageName("Transcript Update");
    const {
      userLogin: { loggedUser },
    } = this.props;
    this.props.fetchAudioTracks(
      cookie.load("username"),
      this.state.filterValues.startDate,
      this.state.filterValues.endDate,
      1,
      10
    );
  }

  handleReset() {
    const { records } = this.state;
    records["transcript"] = "";
    records["language"] = "";
    this.setState({ records });
  }

  handleOnChange(e, key, param) {
    var reg = /^[a-zA-Z\s*]*$/i;
    const { records, recordsError } = this.state;

    if (reg.test(e.target.value)) {
      records[param] = e.target.value.replace(/(\r\n|\n|\r)/gm, "");
      recordsError[key] = false;
      this.setState({ records, recordsError });
    } else {
      records[param] = e.target.value.replace(/(\r\n|\n|\r)/gm, "");
      recordsError[key] = true;
      this.setState({ records, recordsError });
    }
    if (
      reg.test(e.target.value) &&
      records[param].transcript !== "" &&
      records[param].language !== ""
    ) {
      this.setState({ disableSubmit: false });
    } else {
      this.setState({ disableSubmit: false });
    }
  }
  rederAudioFiles(list) {
    const { records, recordsError, disableSubmit } = this.state;
    return list.map((item, i) => {
      // records[item.id] = records[item.id]
      //   ? records[item.id]
      //   : { transcript: "", language: "" };
      return (
        <Accordion
          expanded
          key={item.file_path + i}
          className={(i + 1) % 2 === 0 ? "even" : "add"}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <div className="flexhvc">
              {/* <PlayCircleFilledIcon />
                            <p style={{ paddingLeft: 10 }}>{item.file_path.replace(`http://10.101.1.134/rec/`, ``)}</p> */}
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className="audio-result">
              <h3>{item.language}</h3>
              <MuiAudioPlayer src={item.file_path} autoPlay={true} />
              <div className="form-control">
                <TextField
                  error={recordsError[item.id]}
                  id="outlined-multiline-static"
                  label={` ${
                    recordsError[item.id]
                      ? `Letters,space and asterisk(*) only allowed!!!`
                      : "Enter the Transcript "
                  }`}
                  multiline
                  rows="4"
                  // value={records.transcript}
                  onChange={(e) =>
                    this.handleOnChange(e, item.id, "transcript")
                  }
                  onKeyDown={(e) =>
                    this.handleOnChange(e, item.id, "transcript")
                  }
                  variant="outlined"
                />
              </div>
              <br/>
              <br/>
              <br/>
              <div className="form-control">
                <FormControl>
                  <InputLabel id="chooseLanguage">Choose language</InputLabel>
                  <Select
                    id="outlined-multiline-static-language"
                    labelId="chooseLanguage"
                    label={`Choose language`}
                    name="language"
                    // value={records.language}
                    onChange={(e) =>
                      this.handleOnChange(e, item.id, "language")
                    }
                    variant="outlined"
                  >
                    <MenuItem value="English">English</MenuItem>
                    {lang.map((lan, i) => (
                      <MenuItem key={i} value={lan.value} label={lan.label}>
                        {lan.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              {/* props.saveAudioTracks({ item, transcript: transcript[i] }) */}
              <Button
                disabled={
                  disableSubmit ||
                  records.transcript === "" ||
                  records.language === ""
                }
                onClick={() => {
                  this.props.saveAudioTracks({
                    user: cookie.load("username"),
                    item,
                    transcript: records.transcript,
                    language: records.language,
                  });
                  this.handleReset();
                }}
                variant="contained"
                color="primary"
              >
                Submit
              </Button>
            </div>
          </AccordionDetails>
        </Accordion>
      );
    });
  }
  triggerFetchAudio(pageNumber) {
    const {
      filterValues: { startDate, endDate },
    } = this.state;
    let start_date = "";
    let end_date = "";
    if (startDate !== "" && endDate !== "") {
      let sdate = new Date(startDate);
      let edate = new Date(endDate);
      start_date = `${sdate.getFullYear()}-${
        sdate.getMonth() + 1
      }-${sdate.getDate()} 00:00:00`;
      end_date = `${edate.getFullYear()}-${
        edate.getMonth() + 1
      }-${edate.getDate()} 23:59:59`;
    }

    this.props.fetchAudioTracks(
      cookie.load("username"),
      start_date,
      end_date,
      pageNumber,
      pageNumber * 10
    );
    this.setState({ pageNumber });
  }
  handleDateChange(value, key) {
    const { filterValues } = this.state;
    filterValues[key] = value === null ? "" : value;
    this.setState({ filterValues });
  }

  showTheResultCount(pageNumber) {
    let startCount = "";
    let endCount = "";
    startCount = (pageNumber - 1) * 10 + 1;
    endCount =
      this.props.audioList.Count <= 10
        ? this.props.audioList.Count
        : (pageNumber - 1) * 10 + 10;
    return (
      <span>
        Showing {`${startCount} - ${endCount}`} of {this.props.audioList.Count}
      </span>
    );
  }
  render() {
    const { folderName, pageNumber, filterValues } = this.state;
    const { audioList, loading } = this.props;
    console.log(audioList);

    return (
      <div className="right-section">
        <div className="parentTable">
          <Header page="Audio Transcription" />
          <div className="audio-to-trans-page">
            {/* <div className="userInput">
                    {/* <TextField
                        id="outlined-disabled"
                        label="Enter the Folder Name"
                        value={folderName}
                        onChange={(value) => [this.setState({ folderName: value.target.value })]}
                        variant="outlined"
                    /> */}
            {/* <DatePicker
                        control="date"
                        label="Start Date"
                        keys="startDate"
                        value={filterValues.startDate === '' ? null : filterValues.startDate}
                        format="MM/dd/yyyy"
                        handleDateChange={(value, key) => this.handleDateChange(value, key)}
                    />
                    <DatePicker
                        control="date"
                        label="End Date"
                        keys="endDate"
                        value={filterValues.endDate === '' ? null : filterValues.endDate}
                        format="MM/dd/yyyy"
                        handleDateChange={(value, key) => this.handleDateChange(value, key)}
                    />
                    <div className="btn-wrapper">
                        <Button
                            disabled={(filterValues.endDate !== '' && filterValues.startDate !== '') ? false : true}
                            onClick={() => this.triggerFetchAudio(1)}
                            variant="contained"
                            color="primary">
                            Submit
                        </Button>
                    </div> */}
            {/* </div> */}
            {loading ? (
              <Loader />
            ) : (
              <div className="audio-result-contnet">
                {audioList.data.length >= 1 ? (
                  this.rederAudioFiles(audioList.data)
                ) : (
                  <p style={{ textAlign: "center", padding: 20 }}>
                    No data Found!!.
                  </p>
                )}
                {/* <p style={{ textAlign: "center", padding: 20 }}>Enter the File name to dispaly the Audio files.</p> */}
              </div>
            )}

            {audioList.Count > 0 ? (
              <div className="pagination">
                <span className="tcont">
                  Totally Completed:{audioList.totallyCompleted}
                </span>
                <div className="pagination-buton">
                  {this.showTheResultCount(pageNumber)}
                  {/* <span>Showing {`${(pageNumber - 1) * 10 + 1} - ${(pageNumber - 1) * 10 + 10}`} of {audioList.Count}</span> */}
                  {pageNumber >= 2 ? (
                    <a
                      onClick={(e) => [
                        e.preventDefault(),
                        this.setState({ pageNumber: pageNumber - 1 }),
                        this.triggerFetchAudio(pageNumber - 1),
                      ]}
                      href="#"
                    >
                      Prev
                    </a>
                  ) : null}

                  {audioList.Count >= 11 ? (
                    <a
                      onClick={(e) => [
                        e.preventDefault(),
                        this.setState({ pageNumber: pageNumber + 1 }),
                        this.triggerFetchAudio(pageNumber + 1),
                      ]}
                      href="#"
                    >
                      Next
                    </a>
                  ) : null}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

AudioToTrack.propTypes = {
  audioList: PropTypes.object,
};

function mapStateToProps(state) {
  const { userLogin } = state;
  const { audioList, loading, success, error } = state.AudioToTrackReducer;

  return {
    audioList,
    loading,
    userLogin,
    success,
    error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchAudioTracks: (username, start_date, end_date, start_page, end_page) =>
    dispatch(
      fetchAudioTracks(username, start_date, end_date, start_page, end_page)
    ),
  saveAudioTracks: (item) => dispatch(saveAudioTracks(item)),
  setPageName: (a) => dispatch(setPageName(a)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AudioToTrack)
);
